import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Database, AlertCircle, CheckCircle2 } from "lucide-react";

export default function AbaNinjaPanel() {
  const [status, setStatus] = useState(null);
  const [my, setMy] = useState({ customers: [], offers: [], invoices: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([api.get("/abaninja/status"), api.get("/abaninja/me")])
      .then(([s, m]) => { setStatus(s.data); setMy(m.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div data-testid="abaninja-panel">
      <h2 className="font-heading text-3xl font-bold text-[#1A2433] mb-2">AbaNinja Integration</h2>
      <p className="text-slate-600 mb-6">Anbindung an Ihre Buchhaltung.</p>

      {status && (
        <div className={`flex items-start gap-3 p-4 rounded-xl mb-8 ${status.configured ? "bg-emerald-50 border border-emerald-200" : "bg-amber-50 border border-amber-200"}`}>
          {status.configured ? <CheckCircle2 className="w-5 h-5 text-emerald-600 mt-0.5" /> : <AlertCircle className="w-5 h-5 text-amber-600 mt-0.5" />}
          <div className="text-sm">
            <div className="font-semibold text-[#1A2433]">
              Status: {status.mode === "live" ? "Live" : "Vorbereitet (Stub-Modus)"}
            </div>
            <div className="text-slate-600 mt-1">{status.note}</div>
          </div>
        </div>
      )}

      <div className="grid md:grid-cols-3 gap-4 mb-6">
        <Stat label="Kunden (vorgemerkt)" value={my.customers?.length || 0} />
        <Stat label="Angebote" value={my.offers?.length || 0} />
        <Stat label="Rechnungen" value={my.invoices?.length || 0} />
      </div>

      <Section title="Angebote" rows={my.offers} render={(o) => `${o.payload.service || "—"}  ·  CHF ${(o.payload.total_chf || 0).toLocaleString("de-CH")}`} />
      <Section title="Kunden" rows={my.customers} render={(c) => `${c.payload.name}  ·  ${c.payload.email}`} />
    </div>
  );
}

function Stat({ label, value }) {
  return (
    <div className="border border-slate-200 rounded-xl p-5">
      <div className="text-xs uppercase tracking-wider text-slate-500">{label}</div>
      <div className="font-heading text-3xl font-bold text-[#1A2433] mt-1">{value}</div>
    </div>
  );
}

function Section({ title, rows, render }) {
  if (!rows || rows.length === 0) return null;
  return (
    <div className="mt-6">
      <h3 className="font-heading text-lg font-semibold text-[#1A2433] mb-3">{title}</h3>
      <ul className="space-y-2">
        {rows.map((r) => (
          <li key={r.id} className="bg-slate-50 px-4 py-3 rounded-md text-sm text-slate-700 flex justify-between">
            <span>{render(r)}</span>
            <span className="text-xs text-slate-400">{new Date(r.created_at).toLocaleDateString("de-CH")}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
